// extracted by mini-css-extract-plugin
module.exports = {"container":"Cta_container__rJ_w6","content":"Cta_content__HsF53","paragraph":"Cta_paragraph__MwQnF","title":"Cta_title__kNzl7","wrapper":"Cta_wrapper__HYBCB"};